import React from "react";
import { ThemeToggler } from "gatsby-plugin-dark-mode";
import styled from "@emotion/styled";

import { Switch } from "~/components/FormComponents";
import { DarkMode, LightMode } from "~/components/Icons";

const ThumbIcon = styled.span({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "50%",
  background: "#fff",
  color: "#222",
  "& svg": {
    fontSize: 14,
  },
});

type ThemeTogglerProps = {
  theme: string;
  toggleTheme: (theme: string) => void;
};

const DarkModeToggle = () => (
  <ThemeToggler>
    {({ theme, toggleTheme }: ThemeTogglerProps) => {
      if (theme == null) {
        return null;
      }
      return (
        <Switch
          icon={
            <ThumbIcon>
              <LightMode />
            </ThumbIcon>
          }
          checkedIcon={
            <ThumbIcon>
              <DarkMode />
            </ThumbIcon>
          }
          onChange={isDark => toggleTheme(isDark ? "dark" : "light")}
          checked={theme === "dark"}
          label="Dark mode"
        />
      );
    }}
  </ThemeToggler>
);

export default DarkModeToggle;
